import { APICallV3Get } from 'reactApp/api/APICall';

export class ProductListAPICall extends APICallV3Get {
    _method = 'billing/product/list';
}
